var m={S:{min:0,max:767},M:{min:768,max:1023},L:{min:1024,max:1279},XL:{min:1280,max:2400}};export{m as default};
